module.exports = __webpack_public_path__ + "img/gr-h.5c8b2484.jpg";